export class CookieUtil {

  public getAllCookies() {
      const cookies = document.cookie;
      return cookies;
  }

  public setCookie(name: string, value: string, path: string = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expires: string = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';path=' + path;
  }
  public getCookie(name: string) {
    const ca: string[] = document.cookie.split(';');
    const caLen: number = ca.length;
    const cookieName = name + '=';
    let c: string;

    for (let i = 0; i < caLen; i += 1) {
      c = ca[i].trim().replace(/^\s\+/g, '');

      if (c.indexOf(cookieName) !== -1 && c.indexOf(cookieName) === 0) {
        return c.substring((cookieName.length), c.length);
      }
    }
    return '';
  }

  public unset = (name: string) => {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
  }

  /**
   * Get the numeric value for the cookieName and fieldName sent in.
   *
   * @returns The number, or null if there is no logged-in user
   */
  public getNumericValue(cookieName: string, fieldName: string): number {
    const cookie = this.getCookie(cookieName);
    const regex: RegExp = RegExp(`${fieldName}=(\\d+)`);
    const matches = regex.exec(cookie);
    return matches ? Number(matches[1]) : null;
  }

  /**
   * Get the string value for the cookieName and fieldName sent in.
   *
   * @returns The string, or null if there is no logged-in user
   */
  public getStringValue(cookieName: string, fieldName: string): string {
    const cookie = this.getCookie(cookieName);
    const regex: RegExp = RegExp(`${fieldName}=([\\w-\.=]+)`);
    const matches = regex.exec(cookie);
    return matches ? matches[1] : null;
  }

}
